import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { PageLayout } from '../../common/components/Layout/PageLayout';
import { useHasPermission } from '../../common/hooks/useHasPermission';
import { useCurrentUser } from '../../common/hooks/useCurrentUser';
import { UserPermission } from '../../utils/permissions';

import { Main } from './Main/Main';
import { AboutHR } from './AboutHR/AboutHR';
import { Welcome } from './Welcome/Welcome';
import { TechHistory } from './TechHistory/TechHistory';
import { Tours } from './Tours/Tours';
import { Contacts } from './Contacts/Contacts';
// import { DressCode } from './DressCode/DressCode';
import { Banner } from './Banner/Banner';
import { Structure } from './Structure/Structure';
import { CampusMap } from './CampusMap/CampusMap';
import { DocumentsSectionsList } from './Documents/Documents';
import { useDocumentSectionsInWelcomePage } from './Documents/useDocumentSectionsInWelcomePage';
import s from './WelcomePage.module.scss';

export default function WelcomePage() {
  const { user } = useCurrentUser();
  const canEdit = useHasPermission(user, UserPermission.DocumentCrud);

  const documentSectionsQuery = useDocumentSectionsInWelcomePage();
  const documentSections = documentSectionsQuery.state.data || [];

  useEffect(() => {
    documentSectionsQuery.store.client.reFetchObservableQueries();
  }, [documentSectionsQuery.store.client]);

  return (
    <PageLayout contentClassName={s.WelcomePage__content} isLanding={true}>
      <Helmet title={'Работа в МФТИ'} />

      <Main />
      <AboutHR />
      <Welcome />
      <TechHistory />
      <Tours />
      <Structure />
      <Contacts />
      {/*<DressCode />*/}
      <Banner />
      <DocumentsSectionsList
        documentSections={documentSections}
        editable={canEdit}
      />
      <CampusMap />
    </PageLayout>
  );
}
